// src/pages/IslemeAlinanApplicationsPage.js
import React from 'react';
import ApplicationsPage from './ApplicationsPage';

const PendingApplicationsPage = () => {
  return <ApplicationsPage statusName="işleme_alındı" pageTitle="İşleme Alınan Başvurular" />;
};

export default PendingApplicationsPage;